import { init, setUser } from "@sentry/react";
import { client } from "./client.ts";
import { config } from "./config.ts";

init({
  // This value can be included in the app bundle, i.e. it is not a secret.
  dsn: `https://45fd318d22620cbf5230439e683aa992@o4510251181211648.ingest.de.sentry.io/4510260949483600`,
  enabled: config.VITE_ENABLE_SENTRY,
  environment: config.VITE_ENV,
  sendDefaultPii: false,
});

client.addEventListener("currentUser", (event) => {
  setUser({ id: event.detail.currentUser.id });
});

client.addEventListener("sessionExpired", () => {
  setUser(null);
});
